import React, { FC } from 'react'

import { Box, Checkbox, FormControl, useTheme } from '@mui/material'
import TableCell from '@mui/material/TableCell'

import { addTradeToMassFill, removeTradeFromMassFill } from '../../pages/TradingLog'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

export const TradingLogBodyCellSelect: FC<{ id: number }> = ({ id }) => {
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()
  const { selectedTrades, trades } = useAppSelector((state) => state.tradingLog)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const trade = trades.find((item) => id === Number(item.id))

    if (trade) {
      const journalingTrade = {
        id: trade.id,
        journalingCompletion: Number(trade.journalingCompletion),
      }

      if (e.target.checked) {
        dispatch(addTradeToMassFill(journalingTrade))
      } else {
        dispatch(removeTradeFromMassFill(journalingTrade))
      }
    }
  }

  const checked = selectedTrades.filter((item) => item.id === id)

  return (
    <TableCell
      sx={{
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'right',
        padding: spacing(1.25),
        textTransform: 'capitalize',
        '& div': {
          justifyContent: 'right',
        },
      }}
    >
      <Box display="flex" flexDirection="row">
        <FormControl>
          <Checkbox checked={Boolean(checked.length)} onChange={handleChange} />
        </FormControl>
      </Box>
    </TableCell>
  )
}
